import React from 'react';
import Navbar from './../components/Navbar';
import Header from './../components/Header';
import { Container, Typography, List, ListItem, ListItemIcon, ListItemText, Grid } from '@material-ui/core';
import { Home as HomeIcon, AssignmentInd, Fingerprint, PermIdentity, Cake, Phone, 
        EventNote, Wc, Equalizer, Description } from '@material-ui/icons';
import { Helmet } from 'react-helmet';
import { parseJwt } from './../utils/functions';
import { IUsuario } from './interfaces';
import moment from 'moment';

const Home = () => {
    const usuario: IUsuario = parseJwt(localStorage.getItem("jwt") || "");
    const personalData = [
        {
            name: "Nombre",
            value: `${usuario.nombre} ${usuario.paterno} ${usuario.materno}`,
            icon: <AssignmentInd />
        },
        {
            name: "Número de cuenta",
            value: usuario.noCuenta,
            icon: <Fingerprint />
        },
        {
            name: "RFC",
            value: usuario.rfc,
            icon: <PermIdentity />
        },
        {
            name: "Fecha de nacimiento",
            value: usuario.fechaNacimiento ? moment(usuario.fechaNacimiento).utc().format("DD/MM/YYYY") : "",
            icon: <Cake />
        },
        {
            name: "Domicilio",
            value: `${usuario.calle || ""} ${usuario.noCasa || ""} ${usuario.colonia || ""} ${usuario.ciudad || ""} ${usuario.codigoPostal || ""}`,
            icon: <HomeIcon />
        },
        {
            name: "Teléfono",
            value: usuario.telefono,
            icon: <Phone />
        },
        {
            name: "Fecha de alta",
            value: moment(usuario.createdAt).format("DD/MM/YYYY"),
            icon: <EventNote />
        },
        {
            name: "Sexo",
            value: usuario.genero,
            icon: <Wc />
        },
        {
            name: "Estatus",
            value: usuario.activo ? "ACTIVO" : "INACTIVO",
            icon: <Equalizer />
        },
        {
            name: "Estado civil",
            value: usuario.estadoCivil,
            icon: <Description />
        },
    ]


    return (
        <section>
            <Helmet>
                <title>InfoISSET | Inicio</title>
            </Helmet>
            <Navbar />
            <Container style={{marginTop: 15}}>
                <Header />
                <Typography variant="h5" style={{marginTop: 15}}>
                    Sus datos personales:
                </Typography>
                <Grid container>
                    <Grid item md={6}>
                        <List>
                            {personalData.filter((element, index) => !(index % 2)).map((element, index) => (
                            <ListItem key={index}>
                                <ListItemIcon>
                                    {element.icon}
                                </ListItemIcon>
                                <ListItemText primary={
                                    <React.Fragment><strong>{element.name}:</strong> {element.value}</React.Fragment>
                                } />
                            </ListItem>
                            ))}
                        </List>
                    </Grid>
                    <Grid item md={6}>
                        <List>
                            {personalData.filter((element, index) => index % 2).map((element, index) => (
                            <ListItem key={index}>
                                <ListItemIcon>
                                    {element.icon}
                                </ListItemIcon>
                                <ListItemText primary={
                                    <React.Fragment><strong>{element.name}:</strong> {element.value}</React.Fragment>
                                } />
                            </ListItem>
                            ))}
                        </List>
                    </Grid>
                </Grid>
            </Container>
        </section>
    );
};

export default Home;